var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box-typical-upload box-typical-upload-in" },
    [
      _vm.config.description
        ? _c(
            "div",
            { staticClass: "alert alert-info", attrs: { role: "alert" } },
            [
              _c("img", {
                attrs: { src: "/img/icons/dragable-bl.svg", alt: "Dragable" }
              }),
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.config.description) }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.files.length > 0 || _vm.rejectedFiles.length > 0
        ? _c("div", { staticStyle: { margin: "1em 0" } }, [
            _c("h6", { staticClass: "uploading-list-title" }, [
              _vm._v("Uploading")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "uploading-list list-unstyled" },
              [
                _vm._l(_vm.files, function(file) {
                  return _c(
                    "li",
                    { key: file.name, staticClass: "uploading-list-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "uploading-list-item-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "uploading-list-item-name" },
                            [
                              _c("i", {
                                staticClass: "font-icon font-icon-cam-photo"
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(file.name) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "uploading-list-item-size" },
                            [_vm._v(_vm._s(_vm.getFileSize(file.size)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "uploading-list-item-close",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.removeFile(file.id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "font-icon-close-2" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "progress" }, [
                        _c("span", {
                          staticClass: "progress-bar",
                          style: "width: " + _vm.uploading[file.name] + "%;"
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "uploading-list-item-progress" },
                        [_vm._v(_vm._s(_vm.uploading[file.name]) + "%")]
                      ),
                      _vm._v(" "),
                      _vm.uploading[file.name] == 100
                        ? _c(
                            "div",
                            { staticClass: "uploading-list-item-speed" },
                            [_vm._v("Done")]
                          )
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.rejectedFiles, function(file) {
                  return _c(
                    "li",
                    {
                      key: file.name,
                      staticClass: "uploading-list-item",
                      staticStyle: { color: "red" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "uploading-list-item-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "uploading-list-item-name" },
                            [
                              _c("i", {
                                staticClass: "font-icon font-icon-cam-photo"
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(file.name) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "uploading-list-item-size" },
                            [_vm._v("Invalid extension")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "uploading-list-item-close",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.removeFile(file.id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "font-icon-close-2" })]
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "drop",
        {
          on: {
            dragleave: _vm.onDragLeave,
            dragover: _vm.onDragOver,
            drop: _vm.onFileDropped
          }
        },
        [
          _c("div", { staticClass: "drop-zone-wrapper" }, [
            _c(
              "div",
              {
                class: [
                  "drop-zone",
                  "thumbnail",
                  _vm.dragging ? "dragover" : ""
                ]
              },
              [
                _vm.value
                  ? [
                      _vm.value
                        ? _c("img", {
                            staticClass: "upload-thumbnail",
                            attrs: {
                              src:
                                _vm.src +
                                "/w250_h250" +
                                "?" +
                                _vm.localTimestamp
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-rounded btn-md btn-primary",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: { click: _vm.openModal }
                        },
                        [
                          _vm._v(
                            "\n                        Replace image\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-rounded btn-md btn-danger",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: { click: _vm.setNullValue }
                        },
                        [
                          _vm._v(
                            "\n                        Delete image\n                    "
                          )
                        ]
                      )
                    ]
                  : [
                      _c("img", {
                        attrs: { src: "/img/icons/cloud-bl.svg", alt: "Cloud" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "drop-zone-caption" }, [
                        _c("h2", [
                          _vm._v(
                            "You haven't assigned an image to this content yet."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Drag an image here to upload directly or select an existing image from your site assets"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-rounded btn-md btn-success",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: { click: _vm.openModal }
                        },
                        [
                          _vm._v(
                            "\n                        Select image\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "btn btn-rounded btn-md btn-file" },
                        [
                          _c("span", [_vm._v("Upload image")]),
                          _vm._v(" "),
                          _c("input", {
                            staticStyle: { left: "-330px", top: "-130px" },
                            attrs: { type: "file", disabled: _vm.disabled },
                            on: { change: _vm.onFileSelected }
                          })
                        ]
                      )
                    ]
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      !_vm._.get(_vm.config, "hide_hint")
        ? _c(
            "div",
            { staticClass: "alert alert-success", attrs: { role: "success" } },
            [
              _vm._m(0),
              _vm._v(" Not sure how to resize your images? We have a "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.72dpi.co.nz/blog/how-to-resize-images-using-canva.html",
                    target: "_blank"
                  }
                },
                [_vm._v("tutorial")]
              ),
              _vm._v(" for that.\n    ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("file-modal-component", {
        attrs: {
          show: _vm.selecting,
          storagePanel: _vm._.get(_vm.config, "storagePanel"),
          storages: _vm._.get(_vm.config, "storages"),
          currentAsset: _vm.asset,
          closeModal: _vm.closeFileModal,
          extensions: _vm.extensions
        },
        on: { change: _vm.updateValue, close: _vm.closeFileModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://www.72dpi.co.nz/blog/how-to-resize-images-using-canva.html",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: { src: "/img/icons/question-gr.svg", alt: "Question" }
        })
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2108c68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2108c68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/ImagePickerComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e2108c68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/ImagePickerComponent.vue
// module chunks = 0